import { Box, Button, Paper, Table, TableContainer, TableHead, TableBody, TableCell, TableRow } from "@mui/material";
import { blueGrey, grey } from "@mui/material/colors";

const infoTableCellSx = {
  fontSize: 17
};

const formatDate = (dateStr) => {
  const [datePart] = dateStr.split(' ');
  const [year, month, day] = datePart.split('-');
  return `${year}/${parseInt(month, 10)}/${parseInt(day, 10)}`;
};

export const NewsTable = ({ newsList, onClickEditButton, onClickDeleteButton }) => {
  const columns = ["ID", "タイトル", "本文", "更新日", ""];
  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            {columns.map((columnName, i) => (
              <TableCell
                key={`${columnName}_${i}`}
                sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
              >
                {columnName}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {newsList
            .map((data, index) => (
              <TableRow
                key={index}
                sx={{
                  "&:hover": {
                    backgroundColor: blueGrey[50],
                  },
                }}
              >
              <TableCell sx={{ ...infoTableCellSx, width: '3%', textAlign: 'right' }}>{data.newsId}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '20%' }}>{data.title}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '50%' }}>
                {(() => {
                  const cleanedText = data.contentText
                  .replace(/\s+/g, '')
                  return cleanedText.length > 100 ? `${cleanedText.slice(0, 100)}...` : cleanedText;
                })()}
              </TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '10%' }}>{formatDate(data.updatedAt)}</TableCell>
              <TableCell sx={{ ...infoTableCellSx, width: '10%' }}>
                <Box display="flex" justifyContent="flex-end">
                  <Button
                    variant="outlined"
                    sx={{ marginRight: 3 }}
                    onClick={onClickEditButton(data.newsId)}
                  >
                    編集
                  </Button>
                  <Button
                    variant="outlined"
                    color="error"
                    onClick={onClickDeleteButton(data.newsId)}
                  >
                    削除
                  </Button>
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
